import { render } from "./HomePage.vue?vue&type=template&id=46c326ea&bindings={\"loggedIn\":\"props\",\"user\":\"props\"}"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"
script.render = render

export default script